import { ShieldCheck, EyeOff, PackageCheck, PhoneCall, TriangleAlert } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";
import { SAFETY } from "@/lib/content";

const ICONS = [ShieldCheck, EyeOff, PackageCheck, PhoneCall];

export default function SafetyGuide() {
  return (
    <section id="safety" data-testid="safety-section" className="bg-ink py-24 text-bone sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow className="text-sage">{SAFETY.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-bone sm:text-5xl">
              {SAFETY.heading}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-bone/70 sm:text-lg">{SAFETY.intro}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2">
          {SAFETY.steps.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal
                key={s.title}
                delay={i * 0.06}
                className="bg-ink p-8 transition-colors duration-500 hover:bg-[#34372f] sm:p-10"
                data-testid={`safety-step-${i}`}
              >
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terracotta/20 text-terracotta">
                    <Icon className="h-5 w-5" strokeWidth={2.2} />
                  </span>
                  <span className="font-serif text-xl italic text-sage">Step {i + 1}</span>
                </div>
                <h3 className="mt-6 font-serif text-2xl font-medium text-bone">{s.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-bone/70">{s.body}</p>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-8 flex items-start gap-3 rounded-2xl bg-rust/15 p-5">
          <TriangleAlert className="mt-0.5 h-5 w-5 shrink-0 text-terracotta" strokeWidth={2.2} />
          <p className="text-sm leading-relaxed text-bone/80">{SAFETY.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
